import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { withTranslation } from "react-i18next";
import { UserApis } from "apis/UserApi";

const UserSelect = ({ value, onChange, isMulti = true, t, role_id, status }) => {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const loadOptions = async (searchValue) => {
        setLoading(true);
        try {
            const response = await UserApis.getVendors({
                page: 1,
                limit: 10,
                search: searchValue,
                status : status,
                role_id : role_id
            });
            
            if (response.data.status) {
                const formattedOptions = response.data.data.map(user => ({
                    value: user.id,
                    label: `${user.firstname} ${user.lastname}`
                }));
                setOptions(formattedOptions);
            }
        } catch (error) {
            console.error('Error loading users:', error);
        }
        setLoading(false);
    };

    useEffect(() => {
        loadOptions(searchTerm);
    }, [searchTerm]);

    const handleInputChange = (newValue) => {
        setSearchTerm(newValue);
    };

    return (
        <Select
            isMulti={isMulti}
            value={value}
            onChange={onChange}
            options={options}
            isLoading={loading}
            onInputChange={handleInputChange}
            placeholder={t("Select Users")}
            noOptionsMessage={() => t("No user found")}
            loadingMessage={() => t("Loading...")}
            className="react-select"
            classNamePrefix="react-select"
        />
    );
};

UserSelect.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ]),
    onChange: PropTypes.func.isRequired,
    isMulti: PropTypes.bool,
    t: PropTypes.func.isRequired,
    role_id: PropTypes.any,
    status: PropTypes.any
};

export default withTranslation()(UserSelect); 